module.exports = __webpack_public_path__ + "img/female-factory-640w.866d47a.jpeg";